import React from 'react'
import { FormattedMessage } from 'react-intl'

export default () => (
  <div className="border-b pb-8">
    <h5 className="uppercase text-sky tracking-wide-2xl">
      <FormattedMessage id="renewals.category" defaultMessage="Member" />
    </h5>
    <h1 className="text-4xl">
      <FormattedMessage id="renewals.header" defaultMessage="Renew memberships" />
    </h1>
    <FormattedMessage tagName="h2" id="renewals.header2" defaultMessage="And get next year even cheaper" />
    <FormattedMessage tagName="p" id="renewals.description.ln1" />
    <FormattedMessage tagName="p" id="renewals.description.ln2" />
  </div>
)